export default __webpack_public_path__ + "static/media/pagePhoto6.7f89ca87.png";